// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"style_formWrapper__HME6z"};